/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteContentLocation$Params {

/**
 * ID stránky
 */
  id: number;

/**
 * ID sekcie
 */
  sectionId: number;
}

export function deleteContentLocation(http: HttpClient, rootUrl: string, params: DeleteContentLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, deleteContentLocation.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('sectionId', params.sectionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

deleteContentLocation.PATH = '/admin/content/{id}/location/{sectionId}';
